import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import { Field, FieldProps, Form, Formik } from 'formik';
import * as React from 'react';
import * as Yup from 'yup';
import { TextField } from '../../../../components/TextField';
import type { OnSubmit } from '../../../../design-system';
import { createSchema } from '../../../../utils/formUtils';

type NewPasswordFormFields = { password: string };

const initialValues: NewPasswordFormFields = { password: '' };

const validationSchema = createSchema<NewPasswordFormFields>({
  password: Yup.string().required('Password is required').min(8, 'Passwords have a minimum length of 8'),
});

export interface NewPasswordFormProps {
  onSubmit: OnSubmit<NewPasswordFormFields>;
}

export const NewPasswordForm: React.FC<NewPasswordFormProps> = ({ onSubmit }) => (
  <Fade in>
    <div>
      <Formik<NewPasswordFormFields>
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        validateOnBlur={false}
        validateOnChange={false}
      >
        {({ errors, isSubmitting }) => (
          <Form>
            <Box textAlign="center">
              <Typography>Please enter a new password to activate your CP-Link account.</Typography>
            </Box>
            <Box mt={2}>
              <Field name="password">
                {({ field: { onBlur, onChange, name, value } }: FieldProps<NewPasswordFormFields['password']>) => (
                  <TextField
                    autoFocus
                    disabled={isSubmitting}
                    error={!!errors.password}
                    fullWidth
                    helperText={errors.password}
                    label="Password"
                    name={name}
                    onBlur={onBlur}
                    onChange={onChange}
                    size="medium"
                    type="password"
                    value={value}
                  />
                )}
              </Field>
            </Box>
            <Box mt={3}>
              <Button color="primary" disabled={isSubmitting} fullWidth size="large" type="submit" variant="contained">
                {isSubmitting ? <CircularProgress size={26} color="inherit" /> : 'Change password'}
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </div>
  </Fade>
);
